module.exports = __webpack_public_path__ + "img/pic-contace us-pc@2x.0fbaaf4.png";